import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

import { get } from '@/core/hooks/useLocalStorage';

/**
 * Локализация React-компонентов. Поддерживаются русский (по умолчанию) и
 * английский языки; файлы переводов копируются сборкой из translations/ в
 * dist/public/locales/. Выбранный пользователем язык хранится в localStorage
 * (ключ `language`, тот же, что использует переключатель в HeaderContent) и
 * применяется сразу при загрузке приложения, до первого рендера.
 *
 * ВАЖНО: react-i18next покрывает пока лишь часть React-компонентов — основная
 * часть интерфейса (AngularJS-шаблоны) остаётся на русском независимо от этой
 * настройки. См. план доработки, этап 2.
 */
const storedLanguage = get<string>('language', 'ru');

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: false,
    lng: storedLanguage,
    fallbackLng: 'ru',
    supportedLngs: ['ru', 'en'],
    load: 'languageOnly',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
